import { createStore, combineReducers, compose, applyMiddleware } from 'redux'
import createHistory from 'history/createBrowserHistory'
import { routerMiddleware, routerReducer } from 'react-router-redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import { reactReduxFirebase, firebaseReducer } from 'react-redux-firebase'
import { firebaseApp } from './base'

export const history = createHistory()

const rrfConfig = {
  userProfile: 'users',
}

const rootReducer = combineReducers({
  firebase: firebaseReducer,
  routing: routerReducer
})

const initialState = {}
const middleware = [
  routerMiddleware(history)
]
let enhancer

const hostname = window && window.location && window.location.hostname
let store

if(hostname !== 'localhost') {
  enhancer = compose(
    reactReduxFirebase(firebaseApp, rrfConfig),
    applyMiddleware(...middleware)
  )
} else {
  enhancer = composeWithDevTools(
      reactReduxFirebase(firebaseApp, rrfConfig),
      applyMiddleware(...middleware)
    )
}

store = createStore(
  rootReducer,
  initialState,
  enhancer
 )

export default store


// WEBPACK FOOTER //
// ./src/store.js